export const SIGNUP = '/auth/register';
export const LOGIN = '/auth/login';
export const GOOGLE_LOGIN = '/auth/google';
export const GOOGLE_REGISTER = '/auth/googleregister';
export const REQUEST_RESET = '/auth/requestreset';
